import { Ctx } from '@app/context'
import { GT_Invoice } from '../../types/invoices'
import { Date_Filter } from '@app/filter/date-filter'
import { DateTime } from 'luxon'
import ClickEvent = JQuery.ClickEvent

export type Invoice_Date_Mode = 'week' | 'month' | 'year'

export class Invoice_List {
    date_mode: Invoice_Date_Mode = 'week'
    date_filter: Date_Filter
    container: HTMLElement|null = null

    constructor( ctx: Ctx ) {
        this.set_invoices( ctx.invoices )
        this.set_container()

        this.date_filter = new Date_Filter()

        this.render_results()
    }

    ready() {
        this.init_actions()
    }

    init_actions() {
        jQuery( '[data-action="update-evaluation-view"]' ).on( 'click', ( e: ClickEvent ) => this.update_view_mode( e.target ) )
        jQuery( '.list-date-container button' ).on( 'click', ( e: ClickEvent ) => this.change_current_date( e ) )
    }

    protected set_container() {
        const element: HTMLElement|null = document.querySelector( '.tab[data-tab="evaluation-invoices"]' )

        if ( ! element ) {
            throw new Error( 'no container found' );
        }

        this.container = element
    }

    protected get_container() {
        if ( ! this.container ) {
            throw new Error( 'no container found' );
        }
        return this.container;
    }

    update_view_mode( target: HTMLElement ) {
        console.log( target, target.dataset.view )
        const mode = target.dataset.view as Invoice_Date_Mode

        if ( ! mode || ! target ) {
            return
        }

        this.clear_results()

        const button_group = target.parentElement

        if ( ! button_group ) {
            throw new Error( 'no buttons' );
        }

        const buttons = button_group.querySelectorAll( 'button' )

        for ( const button of Array.from( buttons ) ) {
            button.classList.remove( 'active' )
        }

        target.classList.add( 'active' )

        this.set_mode( mode )
    }

    set_mode( mode: Invoice_Date_Mode ) {
        console.log( 'set mode', mode, this.get_container() )
        this.date_mode = mode

        this.get_container().dataset.mode = mode

        const now = DateTime.local()

        switch ( mode ) {
            case 'week':
                this.date_filter.update_current_week( now )
                break
            case 'month':
                this.date_filter.update_current_month( now )
                break
            case 'year':
                this.date_filter.update_current_year( now )
                break
        }

        const start = this.date_filter.get_current_start()
        const end  = this.date_filter.get_current_end()

        this.ajax_load_posts( start, end )
    }

    render_results(): void {
        console.log( 'render invoices' )

        const sum: number = this.calculate_sum()
        this.render_widget_value( 'invoices-sum', `${sum.toLocaleString( 'de-DE' )} €` )

        this.render_widget_value( 'invoices-count', gt_results.invoices.length.toString() )

        const project_ids = new Set(
            gt_results.invoices.map( ( invoice: GT_Invoice ) => invoice.project_post_id )
        )

        this.render_widget_value( 'invoices-projects', project_ids.size.toString() )

        switch ( this.date_mode ) {
            case 'week':
                this.render_week_data()

                // this.render_week_chart()
                break
            case 'month':
                this.render_month_data()

                // this.render_month_chart()
                break
            case 'year':
                this.render_year_data()

                // this.render_year_chart()
                break
        }
    }

    render_week_data() {
        this.render_week_day( 'mon', this.date_filter.current_week?.days?.mon )
        this.render_week_day( 'tue', this.date_filter.current_week?.days?.tue )
        this.render_week_day( 'wed', this.date_filter.current_week?.days?.wed )
        this.render_week_day( 'thu', this.date_filter.current_week?.days?.thu )
        this.render_week_day( 'fri', this.date_filter.current_week?.days?.fri )
    }

    render_week_day( day: string, date?: DateTime ): void {
        const table: HTMLElement|null = this.get_container().querySelector( '.evaluation-data[data-date="week"]' )

        if ( ! table || ! date ) {
            return
        }

        const map: string[]  = [ 'MO', 'DI', 'MI', 'DO', 'FR', 'SA', 'SO' ]

        const weekday: string = map[date.weekday - 1]

        const invoices: GT_Invoice[] = gt_results.invoices.filter(
            ( invoice: GT_Invoice ): boolean => {
                if ( ! invoice.payment_date ) {
                    return false;
                }

                const dt = DateTime.fromSQL(
                    invoice.payment_date,
                )

                return dt.hasSame( date, 'day' )
            }
        )

        const sum: number = invoices.reduce(
            ( accumulator: number, currentValue: GT_Invoice ): number => accumulator + currentValue.amount,
            0,
        )

        const value: string = sum > 0 ? `${sum.toLocaleString( 'de-DE' )} €` : '-'

        const row = table.querySelector( `tr[data-day="${day}"]` ) as HTMLElement

        row.innerHTML = `
            <td data-cell="date-badge">
                <span class="badge">${weekday}</span>
            </td>
            <td data-cell="invoice-payment-date">
                <i class="calendar alternate outline icon"></i> 
                ${date.toFormat( 'D' )}
            </td>
            <td data-cell="invoice-sum" class="right aligned">${value}</td>
        `
    }

    render_month_data() {
        const table: HTMLElement|null = document.querySelector( '.evaluation-data[data-date="month"]' )

        if ( ! table ) {
            return
        }

        const tbody = table.querySelector( 'tbody' ) as HTMLElement
        tbody.innerHTML = ''

        const start = this.date_filter.current_month.start_of_month
        const end = this.date_filter.current_month.end_of_month

        let monday = start.startOf( 'week' )

        console.log( start.toFormat( 'D' ), end.toFormat( 'D' ) )

        while ( monday <= end ) {
            tbody.appendChild( this.render_month_week( monday ) )
            console.log( 'monday', monday.toFormat( 'D' ) )
            monday = monday.plus( { 'weeks': 1 } )
        }
    }

    render_month_week( monday: DateTime ) {
        const tr: HTMLElement = document.createElement( 'tr' )

        const start = monday < this.date_filter.current_month.start_of_month ? this.date_filter.current_month.start_of_month : monday
        const end = monday.endOf( 'week' ) > this.date_filter.current_month.end_of_month ? this.date_filter.current_month.end_of_month : monday.endOf( 'week' )

        const results = gt_results.invoices.filter(
            ( invoice: GT_Invoice ): boolean => {
                if ( ! invoice.payment_date ) {
                    return false;
                }

                const dt = DateTime.fromSQL( invoice.payment_date )

                return dt >= start && dt <= end
            }
        )

        const sum = results.reduce(
            ( accumulator: number, currentValue: GT_Invoice ): number => accumulator + currentValue.amount,
            0,
        )

        const value: string = sum > 0 ? `${sum.toLocaleString( 'de-DE' )} €` : '-'

        tr.innerHTML = `
             <td data-cell="date-badge"><span class="badge">KW ${monday.toFormat( 'WW/kkkk' )}</span></td>
            <td data-cell="invoice-payment-date">
                <i class="calendar alternate outline icon"></i>                
                ${start.toFormat( 'D' )} - ${end.toFormat( 'D' )}
            </td>
            <td class="right aligned" data-cell="invoice-sum">${value}</td>
        `

        return tr
    }

    render_year_data() {
        const table: HTMLElement|null = document.querySelector( '.evaluation-data[data-date="year"]' )

        if ( ! table ) {
            return
        }

        const tbody = table.querySelector( 'tbody' ) as HTMLElement
        tbody.innerHTML = ''

        tbody.appendChild( this.set_year_month( 'Januar', 1 ) )
        tbody.appendChild( this.set_year_month( 'Februar', 2 ) )
        tbody.appendChild( this.set_year_month( 'März', 3 ) )
        tbody.appendChild( this.set_year_month( 'April', 4 ) )
        tbody.appendChild( this.set_year_month( 'Mai', 5 ) )
        tbody.appendChild( this.set_year_month( 'Juni', 6 ) )
        tbody.appendChild( this.set_year_month( 'Juli', 7 ) )
        tbody.appendChild( this.set_year_month( 'August', 8 ) )
        tbody.appendChild( this.set_year_month( 'September', 9 ) )
        tbody.appendChild( this.set_year_month( 'Oktober', 10 ) )
        tbody.appendChild( this.set_year_month( 'November', 11 ) )
        tbody.appendChild( this.set_year_month( 'Dezember', 12 ) )
    }

    set_year_month( name: string, index: number  ) {
        const tr = document.createElement( 'tr' )

        const results: GT_Invoice[] = gt_results.invoices.filter(
            ( invoice: GT_Invoice ): boolean => {
                if ( ! invoice.payment_date ) {
                    return false;
                }

                const dt = DateTime.fromSQL( invoice.payment_date )

                console.log( 'year', dt.year, 'month', dt.month )

                return dt.year === this.date_filter.current_year.year && dt.month === index
            }
        )

        const start = DateTime.fromObject(
            {
                year: this.date_filter.current_year.year,
                month: index,
            }
        )

        const end = start.endOf( 'month' )

        const sum = results.reduce(
            ( accumulator: number, currentValue: GT_Invoice ): number => accumulator + currentValue.amount,
            0,
        )

        const value: string = sum > 0 ? `${sum.toLocaleString( 'de-DE' )} €` : '-'

        tr.innerHTML = `
            <td data-cell="date-badge"><span class="badge">${name}</span></td>
            <td data-cell="invoice-payment-date">
                <i class="calendar alternate outline icon"></i>                
                ${start.toFormat( 'D' )} - ${end.toFormat( 'D' )}
            </td>
            <td class="right aligned" data-cell="invoice-sum">${value}</td>
        `

        return tr
    }

    calculate_sum() {
        return gt_results.invoices.reduce(
            ( accumulator: number, currentValue: GT_Invoice ): number => accumulator + currentValue.amount,
            0,
        )
    }

    render_widget_value( name: string, value: string ) {
        const widget = document.querySelector( `[data-evaluation="${name}"]` )

        if ( ! widget ) {
            return
        }

        const content = widget.querySelector( '.content' )!
        content.innerHTML = value
    }

    public set_invoices( posts: GT_Invoice[] = [] ) {
        gt_results.invoices = posts
    }

    clear_results() {
        console.log( 'clearing' )
        this.clear_week_results()
        this.clear_month_results()
        this.clear_year_results()
    }

    clear_week_results() {
        const rows  = this.get_container().querySelectorAll( '.evaluation-data[data-date="week"] tbody tr' )

        for ( const row of Array.from( rows ) ) {
            row.innerHTML = ''
        }
    }

    clear_month_results() {
        const tbody  = this.get_container().querySelector( '.evaluation-data[data-date="month"] tbody' ) as HTMLElement
        tbody.innerHTML = ''
    }

    clear_year_results() {
        const tbody  = this.get_container().querySelector( '.evaluation-data[data-date="year"] tbody' ) as HTMLElement
        tbody.innerHTML = ''
    }

    change_current_date( e: ClickEvent ) {
        console.log( 'change current date',  e.target )

        this.clear_results()

        const trigger: HTMLButtonElement = e.currentTarget
        const offset: number = trigger.classList.contains( 'next-date' ) ? 1 : -1

        switch ( this.date_mode ) {
            case 'week':
                this.date_filter.change_current_week( offset )
                break

            case 'month':
                this.date_filter.change_current_month( offset )
                break

            case 'year':
                this.date_filter.change_current_year( offset )
                break
        }

        const start = this.date_filter.get_current_start()
        const end  = this.date_filter.get_current_end()

        this.ajax_load_posts( start, end )
    }

    protected disable_filter_interactions() {
        this.date_filter.disable_filter_interactions()

        const buttons = this.get_container().querySelectorAll( '#list-invoices-view-buttons button' )
        for ( const button of Array.from( buttons ) ) {
            button.classList.add( 'disabled' )
        }

        const segments = this.get_container().querySelectorAll( '.ui.segment' )
        for ( const segment of Array.from( segments ) ) {
            segment.classList.add( 'loading' )
        }
    }

    protected enable_filter_interactions() {
        this.date_filter.enable_filter_interactions()

        const buttons = this.get_container().querySelectorAll( '#list-invoices-view-buttons button' )
        for ( const button of Array.from( buttons ) ) {
            button.classList.remove( 'disabled' )
        }

        const segments = this.get_container().querySelectorAll( '.ui.segment' )
        for ( const segment of Array.from( segments ) ) {
            segment.classList.remove( 'loading' )
        }
    }

    protected ajax_load_posts( start: DateTime, end: DateTime ) {

        this.disable_filter_interactions()

        if ( ! start.isValid || ! end.isValid ) {
            return false
        }

        const { ajax_url, nonce } = gt_ajax_object

        const action = 'load_invoices'

        const data = {
            action,
            start: start.toFormat( 'yyyy-MM-dd' ),
            end: end.toFormat( 'yyyy-MM-dd' ),
            mode: this.date_mode,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                gt_results.invoices = response.invoices

                this.render_results()
                this.enable_filter_interactions()
            }
        )
    }

}
